import { useEffect, useState } from "react";
import { CheckCircle2, AlertCircle } from "lucide-react";
import api from "@/lib/api";

export default function ReferralsTab() {
  const [refs, setRefs] = useState([]);

  useEffect(() => { api.get("/admin/referrals").then((r) => setRefs(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-referrals">
      <h1 className="font-display font-bold text-3xl mb-1">Referrals</h1>
      <p className="text-ink/60 mb-6">We auto-check each "referred by" against paid customers.</p>

      {refs.length === 0 ? (
        <div className="brut-card p-6 text-ink/60">No referrals submitted yet.</div>
      ) : (
        <div className="space-y-3">
          {refs.map((r) => (
            <div key={r.order_id} className="brut-card p-5 flex flex-wrap justify-between gap-3 items-center" data-testid={`referral-${r.order_id.slice(0,8)}`}>
              <div>
                <div className="font-display font-bold">{r.customer_name} <span className="text-ink/40 text-sm">({r.email})</span></div>
                <div className="text-sm text-ink/60">Says referred by: <b>{r.referred_by}</b></div>
              </div>
              {r.is_valid_referral ? (
                <span className="tag-pill bg-green-200" data-testid="referral-valid"><CheckCircle2 className="w-4 h-4" /> Verified — matched {r.referrer_match}</span>
              ) : (
                <span className="tag-pill bg-orange-200" data-testid="referral-invalid"><AlertCircle className="w-4 h-4" /> No matching past customer</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
